import Moment from "moment";
import { auth } from "../services/auth";
import { useState, useEffect, Fragment } from "react";
import Pagination from "../pagination/pagination";
import TicketComment from "../components/TicketComment";
import GeneralPopup from "../shared/GeneralPopup";
import { Helmet } from "react-helmet";
import { getTicket, addNewTicket, getUserTicket, getAllTickets } from "../services/helpDesk";
import styles from "../css/helpDesk.module.css";
import Loader from "../shared/Loader";

function HelpDesk() {
  let PageSize = 15;
  let data = [];
  let totalRecords = 16;

  const [currentPage, setCurrentPage] = useState(1);
  const [post, setPost] = useState(null);
  const [ticket, setTicket] = useState();
  const [description, setDescription] = useState();
  const [title, setTitle] = useState();
  const [hasError, setHasError] = useState(false);
  const [newTicket, setNewTicket] = useState(false);
  const [showPopup, setPopup] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const user = auth().getUser();
  const isAdmin = auth().isAdmin();
  const token = auth().getToken();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const togglePopup = (value) => {
    setPopup(!showPopup);
  };

  const closePopup = () => {
    setPopup(!showPopup);
  };

  useEffect(() => {
    if (isAdmin) {
      getAllTickets(currentPage, PageSize, config).then((response) => {
        setPost(response.data);
      });
    } else {
      getUserTicket(user, currentPage, PageSize, config).then((response) => {
        setPost(response.data);
      });
    }
  }, [currentPage, newTicket]);

  if (post != null) {
    data = post.data;
  }

  if (post?.totalRecords != null) {
    totalRecords = post?.totalRecords;
  }

  const selectTicket = (value, refresh) => {
    getTicket(value, config).then((response) => {
      setTicket(response.data);
      if (refresh) {
        togglePopup(!togglePopup);
      }
    });
  };

  const addTicket = (value) => {
    setIsLoading(true);
    addNewTicket(user, title, description, config)
      .then((response) => {
        setSuccess(true);
        setNewTicket(!newTicket);
        setDescription("");
        setTitle("");
        setHasError(false);
      })
      .catch((error) => {
        setHasError(true);
        setSuccess(false);
        setError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <section className="flex flex-col my-20 px-3 md:px-5 lg:px-5">
      <Helmet>
        <title>Dailysocialboost | Help Desk</title>
      </Helmet>
      <h2 className="text-xl font-bold my-5">Help Desk</h2>
      <div className="flex flex-col gap-3">
        <div className="flex flex-col my-5 bg-white border-2 border-gray-50 shadow-md p-2 rounded-xl">
          <h2 className="text-xl font-bold">Add Ticket</h2>
          <div className="my-5 flex flex-col gap-5">
            <label className="uppercase font-semibold" htmlFor="title">
              Subject
            </label>
            <input
              placeholder="Enter subject"
              className={`h-8 ${styles.helpDesk}`}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              type="input"
              name="title"
              id="title"
              required
            />
          </div>
          <div className="my-5 gap-5">
            <label className="uppercase font-semibold" htmlFor="description">
              Message
            </label>
            <textarea
              placeholder="Enter message"
              className={`h-28 ${styles.helpDesk}`}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              type="textarea"
              name="description"
              id="description"
              required
            />
          </div>
          <button
            className={`self-center my-5 px-20 py-3 ${styles.addTicketBtn}`}
            id={ticket?.id}
            onClick={(e) => addTicket(e.target.id)}
            disabled={!title || !description}
            type="submit"
            value="Add ticket"
          >
            Add ticket
          </button>
          <div>
            <div
              className={`flex flex-col ${
                isLoading ? "justify-center" : hasError ? "justify-center" : "justify-center"
              }`}
            >
              {isLoading ? (
                <div className="my-5 mx-20">
                  {" "}
                  <Loader styles={"w-12 h-12"}></Loader>{" "}
                </div>
              ) : hasError ? (
                <div
                  key={Math.random()}
                  className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
                  role="alert"
                >
                  <svg
                    aria-hidden="true"
                    className="flex-shrink-0 inline w-5 h-5 mr-3"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <div>
                    <span className="font-medium">Error!</span> {error}
                  </div>
                </div>
              ) : null}
            </div>
            {success ? (
              <div
                className="flex p-4 mb-4 text-sm text-white rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
                role="alert"
              >
                <svg
                  aria-hidden="true"
                  className="flex-shrink-0 inline w-5 h-5 mr-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <div>
                  <span className="font-medium">Success!</span> Sucessfully added ticket!
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="flex flex-col bg-white my-5 border-2 border-gray-50 shadow-md p-2 rounded-xl">
          <h2 className="text-xl font-bold my-5">My Tickets</h2>
          {data.length > 0 ? (
            <div className="grid grid-cols-7 gap-2">
              <div className="font-semibold flex flex-row items-center">Ticket ID</div>
              <div className="font-semibold flex flex-row items-center">Title</div>
              <div className="font-semibold flex flex-row items-center">Description</div>
              <div className="font-semibold flex flex-row items-center">Status</div>
              <div
                className={`font-semibold flex flex-row items-center ${
                  isAdmin ? "col-span-1" : "col-span-2"
                }`}
              >
                Created
              </div>
              {isAdmin ? <div className="font-semibold flex flex-row items-center">User</div> : ""}
              <div className="font-semibold flex flex-row items-center"></div>
              <div className="col-span-7">
                <hr />
              </div>
              {data?.map((item, idx) => (
                <Fragment key={item?.id}>
                  <div className="grid grid-cols-8 col-span-8 gap-1 hover:bg-pink-100 transition-all">
                    <div className="flex flex-row items-center">#{item.id}</div>
                    <div className="flex flex-row items-center">{item.title}</div>
                    <div className="flex flex-row items-center truncate ">{item.description}</div>
                    <div className="flex flex-row items-center">{item.ticketStatus?.title}</div>
                    <div
                      className={`flex flex-row items-center text-pink-350  ${
                        isAdmin ? "col-span-1" : "col-span-2"
                      }`}
                    >
                      {Moment(item.created).format("YYYY-MM-DD HH:mm")}
                    </div>
                    {isAdmin ? (
                      <div className="flex flex-row items-center col-span-2 ">{item.email}</div>
                    ) : (
                      ""
                    )}
                    <div className="flex flex-row items-center">
                      <button
                        className="font-semibold"
                        id={item.id}
                        onClick={(e) => selectTicket(e.target.id, true)}
                      >
                        Details
                      </button>
                    </div>
                  </div>
                </Fragment>
              ))}
            </div>
          ) : (
            <>No tickets yet!</>
          )}
        </div>
        <div className="mt-12">
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={totalRecords}
            pageSize={PageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
      <div className="ticket-preview flex flex-col wrap flex-around w-1/3 px-5">
        {showPopup ? (
          <GeneralPopup title="Ticket details" closePopup={togglePopup}>
            <TicketComment
              setNewTicket={setNewTicket}
              newTicket={newTicket}
              ticket={ticket}
              selectTicket={selectTicket}
              closePopup={closePopup}
            />
          </GeneralPopup>
        ) : null}
      </div>
    </section>
  );
}

export default HelpDesk;
